// White-label brand config. `current.json` is generated by `yarn apply-brand <id>`
// from brands/<id>/brand.json — the checked-in copy is always the stift default,
// so plain `yarn start`/`yarn build` produce the stift portal.
import brand from './current.json'

export default brand
